import React from "react";
import { Route } from "react-router-dom";

import EstoqueGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/EstoqueGenerico";
import MovimentacaoEstoqueGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/MovimentacaoEstoqueGenerico";
import ProdutosGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/ProdutosGenerico";
import EntradasGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/EntradasGenerico";
import EstoqueRetornosGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/EstoqueRetornosGenerico";
import AjustesGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/AjustesGenerico";
import SaidasServicoGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/SaidasServicoGenerico";
import SaidasVendasGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/SaidasVendasGenerico";
import SaidasPerdasGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/SaidasPerdasGenerico";
import SaidasConsumoGenerico from "../pages/Templates/Template-Administrativo/Estoque-Generico/SaidasConsumoGenerico";

export const estoqueGenericoRoutes = (
  <>
    <Route path="/suprimentos/:estoqueSlug" element={<EstoqueGenerico />} />

    <Route
      path="/suprimentos/:estoqueSlug/estoque"
      element={<EstoqueGenerico />}
    />

    <Route
      path="/suprimentos/:estoqueSlug/estoque/realizar-movimentacao"
      element={<MovimentacaoEstoqueGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/produtos"
      element={<ProdutosGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/entradas"
      element={<EntradasGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/entradas/retornos"
      element={<EstoqueRetornosGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/entradas/ajustes"
      element={<AjustesGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/saidas"
      element={<SaidasServicoGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/saidas/servicos"
      element={<SaidasServicoGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/saidas/vendas"
      element={<SaidasVendasGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/saidas/perdas"
      element={<SaidasPerdasGenerico />}
    />

    <Route
      path="/:areaSlug/:estoqueSlug/saidas/consumos"
      element={<SaidasConsumoGenerico />}
    />
  </>
);
